"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { useTheme as v } from "../../hooks.js";
import { useIsInverseVariant as a } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: l, size: c = 24 } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = a(), h = l !== null && l !== void 0 ? l : i ? r.colors.inverse : r.colors.neutralHigh, { skinName: t } = v();
    return t.match(/^blau/i) ? /* @__PURE__ */ n("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: h,
                d: "M9.281 16.441h-2.4v-2.4h2.4z"
            }),
            /* @__PURE__ */ e("path", {
                fill: h,
                d: "M12.626 8.675A4.68 4.68 0 0 1 17.301 4a4.68 4.68 0 0 1 4.675 4.675v1.997h-1.362V8.675a3.316 3.316 0 0 0-3.313-3.313 3.316 3.316 0 0 0-3.313 3.313v9.319a2.014 2.014 0 0 1-2.012 2.012H3.988a2.015 2.015 0 0 1-2.012-2.012v-7.322h.016v-.016h10.634zm-8.638 9.969h7.988c.358 0 .65-.292.65-.65v-5.976H3.338v5.976c0 .358.292.65.65.65"
            })
        ]
    })) : t.match(/^o2-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: h,
            d: "M17.798 8.07v1.823c.954.18 1.702 1.035 1.702 2.107v7.857c0 1.18-.92 2.143-2.046 2.143H6.546C5.42 22 4.5 21.036 4.5 19.857V12c0-1.18.92-2.143 2.046-2.143h9.885V8.074c0-2.571-1.977-4.643-4.431-4.643-1.771 0-3.34 1.104-4.088 2.783-.137.356-.546.5-.885.356-.34-.144-.477-.572-.34-.927.92-2.216 3-3.643 5.317-3.643 3.202 0 5.794 2.715 5.794 6.07m-.344 12.499c.374 0 .683-.32.683-.716V12c0-.392-.305-.716-.683-.716H6.546c-.374 0-.683.32-.683.716v7.853c0 .392.305.716.683.716z"
        })
    })) : t.match(/^o2/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: h,
            d: "M17.798 8.07v1.823c.954.18 1.702 1.035 1.702 2.107v7.857c0 1.18-.92 2.143-2.046 2.143H6.546C5.42 22 4.5 21.036 4.5 19.857V12c0-1.18.92-2.143 2.046-2.143h9.885V8.074c0-2.571-1.977-4.643-4.431-4.643-1.771 0-3.34 1.104-4.088 2.783-.137.356-.546.5-.885.356-.34-.144-.477-.572-.34-.927.92-2.216 3-3.643 5.317-3.643 3.202 0 5.794 2.715 5.794 6.07m-.344 12.499c.374 0 .683-.32.683-.716V12c0-.392-.305-.716-.683-.716H6.546c-.374 0-.683.32-.683.716v7.853c0 .392.305.716.683.716z"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: h,
            d: "M19.376 14.15v-.003c0-1.607 0-2.897-.002-2.897v-.004c.006-.094.072-1.2-.689-2.038-.535-.588-1.316-.885-2.322-.885-2.1 0-6.515.006-8.14.008V7.167c0-3.406 2.48-3.798 3.544-3.806.131 0 .274 0 .395.002.677.017 2.927.252 3.473 2.611.078.325.4.524.717.448.32-.075.518-.4.443-.725-.589-2.541-2.765-3.493-4.603-3.538q-.1 0-.208-.002l-.226-.001c-2.283.022-4.722 1.35-4.722 5.014v1.19c-.46.06-1.093.23-1.6.704-.543.507-.82 1.224-.82 2.128l.002 7.74c-.003.06-.07 1.193.703 2.036.532.58 1.303.874 2.289.874l8.717-.005h.003c.084.005 1.353.075 2.235-.76.54-.51.812-1.22.812-2.117zm-1.19-2.952v.002s-.002 5.201.004 7.762c0 .552-.14.955-.429 1.232-.485.464-1.262.443-1.377.44h-.012l-8.76.006c-.638 0-1.111-.163-1.408-.482-.429-.46-.398-1.135-.395-1.18v-7.784c0-.552.145-.969.431-1.238.409-.384 1.02-.42 1.238-.42q.059 0 .077.003h.004q.022.004.045.003h.028l1.201-.002c1.926-.002 5.656-.007 7.536-.007.652 0 1.137.163 1.437.488.42.452.384 1.115.38 1.177m-6.229 5.22h-.204c-1.356-.017-1.356-1.086-1.356-1.487 0-.398 0-1.457 1.33-1.47h.129q.042.003.082.002c1.375.034 1.375 1.126 1.375 1.485 0 .395 0 1.445-1.356 1.47m2.546-1.47c0-2.468-2.02-2.675-2.537-2.69-.062-.002-.132-.002-.202-.002h-.053c-.533.003-2.51.19-2.51 2.675 0 2.493 1.997 2.686 2.53 2.695h.243c.507-.012 2.53-.202 2.53-2.678"
        })
    }));
}, g = s;
export { g as default };
